import React from 'react'
import { motion } from 'framer-motion'
import { HiCheckCircle } from 'react-icons/hi'
import Swal from 'sweetalert2'

const handleGetinTouch = () => {
    Swal.fire({
        html: `
            <div style="display: flex; flex-direction: column; gap: 16px; padding: 8px 0;">
                <a href="tel:+233303955917" style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%); color: white; border-radius: 12px; text-decoration: none; font-weight: 700; font-size: 16px; box-shadow: 0 4px 12px rgba(2, 132, 199, 0.4); transition: all 0.3s ease; border: none;">
                    <span style="font-size: 20px;">📞</span>
                    <span>Call: 0303955917</span>
                </a>
                <a href="mailto:info@alivanymedicalsupplies.com" style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 16px 24px; background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%); color: white; border-radius: 12px; text-decoration: none; font-weight: 700; font-size: 16px; box-shadow: 0 4px 12px rgba(13, 148, 136, 0.4); transition: all 0.3s ease; border: none;">
                    <span style="font-size: 20px;">✉️</span>
                    <span>Email: info@alivanymedicalsupplies.com</span>
                </a>
            </div>
        `,
        title: 'Get in Touch',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: '×',
        cancelButtonColor: 'transparent',
        background: '#f8fafc',
        backdrop: 'rgba(0, 0, 0, 0.5)',
        customClass: {
            popup: 'rounded-2xl border-2 border-medical-blue-200 shadow-2xl relative',
            title: 'text-2xl font-bold text-medical-blue-700 mb-6',
            htmlContainer: 'text-center pb-2',
            cancelButton: '!absolute !top-3 !right-3 !w-10 !h-10 !rounded-full !bg-gray-100 hover:!bg-gray-200 !text-gray-700 !font-bold !text-2xl !flex !items-center !justify-center !transition-all !m-0 !p-0 !border-none !shadow-md hover:!shadow-lg',
        },
        width: '400px',
        buttonsStyling: false,
    })
}

export default function ProductCard({ product, index }) {
    return (
        <motion.div
            initial={{ y: 20 }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
            className="group"
        >
            <div className="bg-white rounded-2xl transition-all duration-300 overflow-hidden border-3 border-gray-300 hover:border-medical-blue-400 h-full flex flex-col group/card shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06),0_0_0_1px_rgba(59,130,246,0.1)] hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04),0_0_0_1px_rgba(59,130,246,0.2),0_0_20px_rgba(2,132,199,0.3)]" style={{ borderWidth: '3px' }}>
                {/* Image Container */}
                <div className="relative overflow-hidden bg-gradient-to-br from-medical-blue-50 via-medical-teal-50 to-medical-green-50 aspect-square">
                    <motion.img
                        src={product.imgSrc}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover/card:scale-110 transition-transform duration-500"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-medical-blue-900/20 via-transparent to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity duration-300"></div>
                    
                    {/* Trust Badge */}
                    <div className="absolute top-4 right-4 bg-gradient-to-r from-medical-blue-600 to-medical-teal-600 text-white backdrop-blur-sm rounded-full px-4 py-2 flex items-center gap-2 text-xs font-bold shadow-xl ring-2 ring-white/50">
                        <HiCheckCircle className="w-4 h-4" />
                        <span>Certified</span>
                    </div>
                    
                    {/* Gradient Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white/80 to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-grow bg-gradient-to-b from-white to-gray-50">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 line-clamp-2 min-h-[3.5rem] group-hover/card:text-medical-blue-700 transition-colors">
                        {product.name}
                    </h3>

                    {/* Trust Indicators */}
                    <div className="flex items-center gap-4 mb-5 p-3 bg-gradient-to-r from-medical-green-50 to-medical-teal-50 rounded-lg border border-medical-green-200">
                        <span className="flex items-center gap-2 text-xs font-semibold text-medical-green-700">
                            <HiCheckCircle className="w-5 h-5 text-medical-green-600" />
                            Quality Assured
                        </span>
                    </div>
                    
                    {/* CTA */}
                    <div className="mt-auto">
                        <button
                            onClick={handleGetinTouch}
                            className="w-full px-4 py-3 bg-gradient-to-r from-medical-blue-600 to-medical-blue-700 text-white font-bold rounded-xl hover:from-medical-blue-700 hover:to-medical-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] text-sm ring-2 ring-medical-blue-200 hover:ring-medical-blue-300"
                        >
                            Request Quote
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

